@if (displayLocation == 'OAOPostApp') {
  <div class="bl-font-color--base" [hidden]="!isDataLoaded">
    <header class="bl-margin-bottom--24">
      <div class="bl-display--flex bl-align-items--center">
        <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 0L18.3269 9.21688L28 10.6948L21 17.8685L22.652 28L14 23.2169L5.348 28L7 17.8685L0 10.6948L9.67307 9.21688L14 0Z"
            fill="#FFD065"
          />
        </svg>
        <h2 class="bl-text-style--display-6 bl-text-transform--capitalize bl-margin-bottom--0 bl-margin-left--16">
          {{ 'crossSell/header' | dictionary }}
        </h2>
      </div>
      <p class="bl-font-color--steel bl-margin-bottom--0">{{ 'crossSell/sub-header-post-app' | dictionary }}</p>
    </header>
    <ng-container *ngTemplateOutlet="crossSellCard"></ng-container>
  </div>
}

@if (displayLocation == 'OLAPostApp') {
  <div class="bl-font-color--base bl-padding-top--32 bl-padding-bottom--48 bl-padding-x--16 bl-padding-x-sm--0" [hidden]="!isDataLoaded">
    <header class="bl-margin-bottom--24">
      <div class="bl-display--flex bl-align-items--center">
        <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 0L18.3269 9.21688L28 10.6948L21 17.8685L22.652 28L14 23.2169L5.348 28L7 17.8685L0 10.6948L9.67307 9.21688L14 0Z"
            fill="#FFD065"
          />
        </svg>
        <h2 class="bl-text-style--display-6 bl-text-transform--capitalize bl-margin-bottom--0 bl-margin-left--16">
          {{ 'crossSell/header' | dictionary }}
        </h2>
      </div>
      <p class="bl-font-color--steel bl-margin-bottom--0">{{ 'crossSell/sub-header-post-app' | dictionary }}</p>
    </header>

    <ng-container *ngTemplateOutlet="crossSellCard"></ng-container>
  </div>
}

<ng-template #crossSellCard>
  <div id="cross-sell-cards-container">
    @for (item of crossSellProducts?.refinanceOffers; track item) {
      <div>
        <dx-cross-sell-card
          class="bl-position--sticky"
          [refinanceOffers]="item"
          (ctaActionEmit)="onLoanClick($event)"
          (openCrossSellPanel)="openCrossSellSlideInPanel($event)"
        ></dx-cross-sell-card>
      </div>
    }

    @for (item of crossSellProducts?.creditOffers; track item) {
      <div>
        <dx-cross-sell-card
          class="bl-position--sticky"
          [newCreditOffers]="item"
          (ctaActionEmit)="onLoanClick($event)"
          (openCrossSellPanel)="openCrossSellSlideInPanel($event)"
        ></dx-cross-sell-card>
      </div>
    }
  </div>
</ng-template>
<ea-slide-in-panel [slidePanelTitle]="docTitle" [(isSlidePanelVisible)]="openSlideInPanel">
  <!-- TODO: Loading doesn't seem to be workin -->
  @if (!isContentLoaded) {
  <ecp-content-spinner [spinnerSmall]="false"></ecp-content-spinner>
  } @else {
    @if (activeCrossSellOffer?.crossSellOffer?.crossSellOption === 'OneClick') {
    <dx-cross-sell-one-click-panel
      class="bl-display--flex bl-align-items--center bl-justify-content--center bl-flex-direction--column bl-gap--16"
      [activeCrossSellOffer]="activeCrossSellOffer" 
      (close)="crossSellComplete($event)"
    >
      <ng-container *ngTemplateOutlet="additionalTermsAndConditions"></ng-container>
    </dx-cross-sell-one-click-panel>
    } @else {
    <ng-container *ngTemplateOutlet="additionalTermsAndConditions"></ng-container>
    }
  }

  <!-- Templates -->

  <ng-template #additionalTermsAndConditions>
    <ng-container *ngTemplateOutlet="stipulations"></ng-container>
    <ng-container *ngTemplateOutlet="arcOSDisclosures"></ng-container>
  </ng-template>

  <ng-template #stipulations>
    @if(showStipulationsOnSlideIn){
    <section id="cross-sell-stipulation"
      class="cross-sell-panel-container bl-block-module bl-width--100 bl-padding-y--24 bl-padding-x--40">
      <h3 class="bl-text-style--display-6 bl-margin-bottom--16">Stipulations</h3>
      <div class="bl-font-weight--400 bl-text-align--left">
        <ul>
          @for (stipulation of stipulationList; track stipulation) {
          <li class="cross-sell-stipulation">{{ stipulation }}</li>
          }
        </ul>
      </div>
    </section>
    }
  </ng-template>

  <ng-template #arcOSDisclosures>
    <section id="arc-os-disclosures"
      class="cross-sell-panel-container bl-block-module bl-width--100 bl-padding-y--24 bl-padding-x--40">
      <h3 class="bl-text-style--display-6 bl-margin-bottom--16">Additional Terms and Conditions</h3>
      @if(termsAndConditionsText){
      <p [innerHTML]="termsAndConditionsText"></p>
      }
      @if(pdfURL){
      <ea-pdf-embed [pdfSrc]="pdfURL"></ea-pdf-embed>
      }
    </section>
  </ng-template>

</ea-slide-in-panel>
